// SubscriptionsPage.jsx
import './SubscriptionPage.css';
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../Auth/AuthContext";
import { Crown, Gift, Rocket, Goal, Check, Briefcase } from "lucide-react";
import "./MyAccountModal.css";

const SubscriptionsPage = () => {
  const { profileData } = useAuthContext();
  const navigate = useNavigate();

  const getPlanIcon = (planType) => {
    switch (planType) {
      case "free-trial":
        return <Gift size={18} />;
      case "starter":
        return <Rocket size={18} />;
      default:
        return <Goal size={18} />;
    }
  };

  const getSessionTypeName = (type) => {
    const names = {
      prepbot: "PrepBot",
      mockbot: "MockBot",
      resume: "ResumeExpert",
      jd: "JDExpert",
    };
    return names[type] || type;
  };

  return (
    <div className="modern-account-modal">
      <div className="subscriptions-section">
        <h1 className="subscriptions-title">Subscriptions</h1>
        <div className="section-header">
          <h3>
            <Briefcase size={20} /> Active Subscriptions
          </h3>
          <button
            className="add-sessions-btn"
            onClick={() => navigate("/pricing")}
          >
            <Crown size={16} />
            Add Sessions
          </button>
        </div>

        <div className="subscriptions-grid">
          {profileData?.subscriptions?.length > 0 ? (
            profileData.subscriptions.map((sub, idx) => (
              <div key={idx} className="subscription-card">
                <div className="sub-header">
                  <span className="sub-type">
                    {getSessionTypeName(sub.session_type)}
                  </span>
                  <span className={`sub-status ${sub.status}`}>
                    {sub.status}
                  </span>
                </div>
                <div className="sub-plan">
                  {getPlanIcon(sub.plan_type)}
                  <span>
                    {sub.plan_type
                      .replace("-", " ")
                      .replace(/\b\w/g, (l) => l.toUpperCase())}{" "}
                    Plan
                  </span>
                </div>
                <div className="sub-details">
                  <div className="sub-price">${sub.price}</div>
                  <div className="sub-sessions">
                    {sub.session_type === "prepbot" ||
                    sub.session_type === "mockbot"
                      ? `${sub.sessions} session${
                          sub.sessions !== 1 ? "s" : ""
                        }`
                      : sub.session_type === "resume"
                      ? `${sub.resume} resume${sub.resume !== 1 ? "s" : ""}`
                      : `${sub.jd} JD${sub.jd !== 1 ? "s" : ""}`}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-subscriptions">
              <Gift size={40} />
              <p>No active subscriptions</p>
              <button onClick={() => navigate("/pricing")}>
                Browse Plans
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionsPage;